import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";

function TableHeader({headerGroups}) {
  return (
    <>
      <TableHead
        sx={{
          backgroundColor: "#eff4ff",
        }}
      >
        {headerGroups.map((headerGroup) => (
          <TableRow {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <TableCell
                {...column.getHeaderProps(column.getSortByToggleProps())}
                sx={{
                  color: "#3366ff",
                }}
              >
                {column.render("Header")}{" "}
                {column.isSorted ? (
                  column.isSortedDesc ? (
                    <ArrowUpward sx={{fontSize: "small"}} />
                  ) : (
                    <ArrowDownward sx={{fontSize: "small"}} />
                  )
                ) : (
                  ""
                )}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableHead>
    </>
  );
}

export default TableHeader;
